
export default function ProcessTimeline() {
  const steps = [
    {
      number: '01',
      title: 'Initial Consultation',
      description: 'We discuss your Granada and Costa del Sol real estate needs and property requirements'
    },
    {
      number: '02',
      title: 'Property Search',
      description: 'Our team identifies suitable properties in Granada and Costa del Sol matching your criteria'
    },
    {
      number: '03',
      title: 'Viewing & Selection',
      description: 'Professional property viewings and expert guidance throughout Granada and Costa del Sol'
    },
    {
      number: '04',
      title: 'Legal Process',
      description: 'Complete support with financing, legal documentation, and settlement'
    },
    {
      number: '05',
      title: 'Property Management',
      description: 'Ongoing property management services for your Granada and Costa del Sol investment'
    }
  ];

  return (
    <section id="process" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="font-['Playfair_Display'] text-5xl font-bold text-gray-900 mb-4">
            Our <strong>Real Estate Process</strong>
          </h3>
          <div className="w-16 h-1 bg-teal-600 mx-auto mb-4"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            A streamlined approach to <strong>Granada and Costa del Sol real estate services</strong> and <strong>property management</strong>
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-teal-200 hidden lg:block"></div>
          
          <div className="space-y-12">
            {steps.map((step, index) => (
              <article 
                key={index}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                <div className={`flex-1 ${index % 2 === 0 ? 'lg:text-right' : 'lg:text-left'}`}>
                  <div className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                    <h4 className="text-2xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h4>
                    <p className="text-gray-700 leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                <div className="relative z-10 flex-shrink-0">
                  <div className="w-20 h-20 rounded-full bg-gradient-to-br from-teal-500 to-teal-600 flex items-center justify-center shadow-lg">
                    <span className="text-2xl font-bold text-white">{step.number}</span>
                  </div>
                </div>

                <div className="flex-1 hidden lg:block"></div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
